import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environment';
import { Observable } from 'rxjs';
import { IApiResponse } from '@app/api/interfaces/common/api-response.interface';
import { IListFilter } from '@app/api/interfaces/common/list-filter';
import { IPaginationMeta, IPaginationRequest } from '@app/api/interfaces/common/pagination-meta.interface';
import { IProjectUser, IProjectUsersQuery } from '@app/api/interfaces/project-user.interface';
import { prepareParamsForRequest } from '@app/core/methods/http-params';
import { SplitRequestService } from '@app/core/services/split-request-by-limit/split-request.service';

@Injectable({
  providedIn: 'root',
})
export class ProjectUsersApiService {
  constructor(
    private readonly httpClient: HttpClient,
    private readonly splitRequestService: SplitRequestService
  ) {}

  public getByProjectId(
    projectId: string,
    query: IProjectUsersQuery = {},
    pagination: Partial<IPaginationRequest> = {
      limit: 300,
    },
    all = true
  ): Observable<IApiResponse<IProjectUser[], IPaginationMeta>> {
    const url = `${environment.apiBaseUrl}/v1/projects/${projectId}/users`;

    const options = {
      params: new HttpParams({
        fromObject: {
          ...prepareParamsForRequest(query as IListFilter),
          ...(pagination || {}),
        },
      }),
      withCredentials: true,
    };

    if (all) {
      return this.splitRequestService.get<IProjectUser, IPaginationMeta>(url, options);
    } else {
      return this.httpClient.get<IApiResponse<IProjectUser[], IPaginationMeta>>(url, options);
    }
  }
}
